import OadpSwitch from './oadp-switch';
export default OadpSwitch;
